export const gameAbandonedNotification = {
    type: 'game-abandoned',
    name: 'Game Abandoned',
    description: 'Sent when a game you were in has ended after one of the players dropped out.',
    defaultEnabled: false,
    text(_data, _context) {
        return `A game you were in has ended after one of the players dropped out.`;
    },
    title() {
        return `Game abandoned`;
    },
    link(data) {
        return `/session/${data.gameSessionId}`;
    },
};
//# sourceMappingURL=gameAbandoned.js.map